// extracted by mini-css-extract-plugin
export default {"employee-container":"Company_employee-container__kL4UN"};